'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'jet-fighter-up';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e518';
var svgPathData = 'M16 416c-8.8 0-16-7.2-16-16L0 272c0-8.8 7.2-16 16-16s16 7.2 16 16l0 51.8 160-139.1 0-83.9c0-15.5 2.5-30.9 7.4-45.5L219.8-5.9C225-21.5 239.6-32 256-32s31 10.5 36.2 26.1l20.4 61.1c4.9 14.7 7.4 30.1 7.4 45.5l0 83.7 160 133.3 0-45.8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-160 0 0 25.4 43.3 43.3c3 3 4.7 7.1 4.7 11.3l0 64c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16l0-64c0-4.2 1.7-8.3 4.7-11.3l43.3-43.3 0-25.4-160 0 0 16c0 8.8-7.2 16-16 16zm176-64L192 227.1 48.4 352 192 352zm128 0l151 0-151-125.8 0 125.8zM272 512l64 0 0-41.4-43.3-43.3c-3-3-4.7-7.1-4.7-11.3l0-315.2c0-12-1.9-24-5.7-35.4L261.9 4.2C261 1.7 258.7 0 256 0s-5 1.7-5.9 4.2L229.7 65.4c-3.8 11.4-5.7 23.4-5.7 35.4L224 416c0 4.2-1.7 8.3-4.7 11.3l-43.3 43.3 0 41.4 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faJetFighterUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;